<template>
  <div :ref="formRef"
       class="securo--form">
        <v-row :class="$vuetify.breakpoint.smAndUp ? 'space-between' : ''"
           no-gutters>
        <v-col cols="12"
               sm="6">
          <v-text-field v-model="plz"
                        v-validate="{ required: true, regex: /^[0-9]{5} ?$/ }"
                        :error-messages="errors.collect('plz')"
                        data-vv-as="Postleitzahl"
                        class="required"
                        name="plz"
                        label="Postleitzahl"
                        @input="onInputPlz" />
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-text-field v-if="cityList.length === 0"
                        v-model="ort"
                        v-validate="{ required: true, regex: regex.ort }"
                        :error-messages="errors.collect('ort')"
                        data-vv-as="Ort"
                        class="required"
                        name="ort"
                        label="Ort"
                        hint="Hauptwohnsitz in Deutschland" />
          <v-combobox v-else
                      v-model="ort"
                      v-validate="{ required: true, regex: regex.ort }"
                      :error-messages="errors.collect('ort')"
                      :items="cityList"
                      data-vv-as="Ort"
                      name="ort"
                      class="required"
                      label="Ort"
                      hint="Hauptwohnsitz in Deutschland" />
        </v-col>

        <v-col 
               cols="12"
               sm="6">
          <date-field-model
                      v-model="geburt"
                      v-validate="mindestalter ?
                          {required: true, date_format: ['DD.MM.YYYY'], before: [maxGeburt, true]} :
                          {required: true, date_format: ['DD.MM.YYYY']}"
                      :error-messages="errors.collect('geburt')"
                      data-vv-as="Geburtsdatum"
                      class="required"
                      hint="tt.mm.jjjj"
                      name="geburt"
                      label="Geburtsdatum"
                      @change="onInputDate($event)" />
        </v-col>

        </v-row>
  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import DateFieldModel from "@/components/DateFieldModel";
import plzOrtMixin from "@/components/helper/plzOrtMixin";
import REGEX from "@/validation/regexes";

export default {
  components: { DateFieldModel },
  mixins: [ValidationMixin, KeyTranslator, twowayBinding, plzOrtMixin],
  props: {
    formRef: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      regex: REGEX
    };
  },
  computed: {
    mindestalter() {
      return this.statePath.split('.')[1] === 'vn' || this.statePath.split('.')[1] === 'kontoinhaber';
    },
    maxGeburt() {
      const now = new Date();
      const day = (now.getDate() < 10 ? '0' : '') + now.getDate();
      const month = ((now.getMonth() + 1) < 10 ? '0' : '') + (now.getMonth() + 1);
      const year = now.getFullYear() - 18;
      return `${day}.${month}.${year}`;
    },
    ...mapTwoWay([
      "plz",
      "ort",
      "geburt"
    ]),
  },
  methods: {
    onInputDate(e){
      console.log(e, this.$store.state.b.vn.geburt, this.geburt);
      
    }
  }
};
</script>

<style>
.securo--form {
  margin-top: 16px !important;
  overflow: auto;
}

.securo--form .v-icon {
  cursor: pointer;
}

</style>

